import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { authorSchema, identitySchema } from '@/core/components';

export const courseSchema = z.object({
  title: z.string().min(3),
  noOfPages: z.number(),
  publisher: identitySchema,
  authors: z.array(authorSchema).min(1),
  year: z.number(),
});

export const defaultCourseValues: DefaultValues<CourseSchema> = {
  title: '',
  noOfPages: 0,
  authors: [],
};

export type CourseSchema = z.infer<typeof courseSchema>;
